import React, { useState, useEffect } from "react";
import axios from "axios";
import "../styles/UserForm.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { validatePassword, validateConfirmPassword } from "../utils/validators";
import logo from "../assets/logo.png";

const ResetPassword = ({ setIsLoggedIn, setUser}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isValid, setIsValid] = useState(true);

  const [errors, setErrors] = useState({
    password: "",
    confirmPassword: "",
  });

  const hasErrors = Object.values(errors).some(Boolean);

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const now = Date.now() / 1000; // seconds

        if (decoded.exp && decoded.exp < now) {
          setErrorMessage("Reset link has expired. Please request a new one.");
          setIsValid(false);
          return;
        }
        setUsername(decoded.username);
        setPassword(decoded.password);
      } catch (err) {
        setErrorMessage("Invalid or expired token.Please raise a forgot password request.");
        setIsValid(false);
      }
    }
  }, [token]);

  useEffect(() => {
    const auth = JSON.parse(localStorage.getItem("auth"));

    if (auth?.user) {
      setUsername(auth.user.username);
    }
  }, []);

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    setErrors((p) => ({ ...p, password: validatePassword(value) }));
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);
    setErrors((p) => ({
      ...p,
      confirmPassword: validateConfirmPassword(password, value),
    }));
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setErrorMessage("");

      if (!username || !password || !confirmPassword) {
        setErrorMessage("Please fill in all fields");

        // Clear error message after 10 seconds
        setTimeout(() => {
          setErrorMessage("");
        }, 5000);
        return;
      }

      // BLOCK LOGIN if any errors exist
      if (hasErrors) {
        setErrorMessage("Please fix the errors below to continue.");
        // Clear error message after 10 seconds
        setTimeout(() => {
          setErrorMessage("");
        }, 5000);
        return;
      }

      setLoading(true);

      const response = await axios.post(
        `/api/reset_password`,
        {
          password,
          username,
        }
      );

      if (response.status === 200) {
        setSuccessMessage("Password reset successfully");
        localStorage.removeItem("auth");
        setIsLoggedIn(false);
        setUser(null);
        setTimeout(() => {
          navigate("/login", { replace: true });
        }, 1200); // lets user see success message briefly
      }
    } catch (err) {
      console.log("error", err);
      setErrorMessage(err?.response?.data?.error?.message || "Reset failed");
    } finally {
      setLoading(false);
    }
    setTimeout(() => {
      setSuccessMessage("");
      setErrorMessage("");
    }, 5000);
  };

  return (
    <div className="page">
      <div className="card">
        {/* <button
          className="modal-close"
          onClick={onClose}
          aria-label="Close modal"
        >
          ×
        </button> */}
        <center><img src={logo} alt="Manis Logo" className="logo" /></center>
        <h2 className="title"><center> Reset Password</center></h2>

        {errorMessage && <div className="error">{errorMessage}</div>}
        {successMessage && <div className="success">{successMessage}</div>}

        {isValid && (
          <>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Username</label>
                <input type="email" value={username} readOnly />
              </div>

              <div className="form-group">
                <label>New Password</label>
                <input
                  type="password"
                  value={password}
                  placeholder="Password"
                  onChange={handlePasswordChange}
                />
                {errors.password && (
                  <small className="error-text">{errors.password}</small>
                )}
              </div>

              <div className="form-group">
                <label>Confirm Password</label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={handleConfirmPasswordChange}
                  placeholder="Confirm Password"
                />
                {errors.confirmPassword && (
                  <small className="error-text">{errors.confirmPassword}</small>
                )}
              </div>

              <button className="button" type="submit" disabled={loading}>
                {loading ? "Resetting..." : "Reset Password"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
